import React from 'react';
// import BarsDots from 'components/common/charts/BarsDots';
import ComponentsComparisonTable from './ComponentsComparisonTable';
function PerformanceHighlights(props) {
  const { info, data } = props;
  return (
    <article className="c-performance-highlights">
      <div className="intro row">
        <div className="column small-12 medium-offset-1 medium-10">
          <h1 className="-light">Index results summary</h1>
          <h2 className="subtitle" dangerouslySetInnerHTML={{ __html: info.title }}></h2>
          <p dangerouslySetInnerHTML={{ __html: info.textTop }}></p>
        </div>
      </div>
      <div className="graphs row">
        <div className="charts column small-12 medium-offset-1 print-8">
          <h2 className="subtitle">{info.titleName}: subcomponent scores</h2>
          <div className="charts-items row">
           {data.map((el, i) => (<div key={`chart${i}`} className="column small-12 medium-6 large-4 bottom-border"> <ComponentsComparisonTable data={el} tableIndex={i} /></div>))}
          </div>
        </div>
      </div>

      <div className="row country-table-description">
        <div className="column small-12 medium-10 medium-offset-1">
          <p dangerouslySetInnerHTML={{ __html: info.textBottom }}></p>
        </div>
      </div>
    </article>
  );
}

PerformanceHighlights.propTypes = {
  info: React.PropTypes.object,
  data: React.PropTypes.array
};

export default PerformanceHighlights;



// WEBPACK FOOTER //
// ./app/components/country-profiles/show/PerformanceHighlights.jsx